import { useAIRovoButtonEnablement } from '@confluence/ai-common/entry-points/useAIRovoButtonEnablement.ts';
import { fg } from '@confluence/feature-gating';
import { PageMode } from '@confluence/page-utils/entry-points/enums.ts';
import { useGetPageMode } from '@confluence/page-utils/entry-points/useGetPageMode.ts';
import { useSessionData } from '@confluence/session-data/entry-points/useSessionData.ts';

/**
 * Hook to determine if nudge recommendation checks should be enabled for live docs.
 *
 * @param contentType - The type of content (e.g., 'page', 'blogpost')
 * @returns boolean — whether live doc nudges are enabled for this content
 */
export const useLiveDocNudgeRecommendationFilter = (contentType: string): boolean => {
	const { isAdminHubAIEnabled } = useSessionData();
	const pageMode = useGetPageMode();
	const isRovoButtonEnabled = useAIRovoButtonEnablement();

	const isLiveDoc = pageMode === PageMode.LIVE;

	/**
	 * Filters to prevent high request volume checking for nudge recommendations on live docs
	 * 1. Feature gate 'confluence_rovo_live_doc_nudges' must be enabled
	 * 2. Page must be a live doc
	 * 3. Rovo Button must be enabled
	 * 4. Content type must be 'page'
	 */
	return (
		isLiveDoc &&
		isRovoButtonEnabled &&
		contentType === 'page' &&
		isAdminHubAIEnabled &&
		// eslint-disable-next-line confluence-feature-gating/no-new-feature-gates -- Existing gate retained during CCP-9677 lint-rule rollout; migration deferred.
		fg('confluence_rovo_live_doc_nudges')
	);
};
